export default __webpack_public_path__ + "static/media/home-right-side.5dccf341.svg";